import { get_for_booking as _get_trips } from 'data/tour-vessel';
import { get_settings } from 'data/agency';
import { get as _get_tours } from 'data/tour';
import { post as post_res } from 'data/reservation';
import { exclusion_string } from 'booking-widget/v1/common/util';
import { get as get_cache } from 'utils/cache';
import { esc_html } from 'utils/strings';

import { 
    to_system_date, 
    tz_display_to_local, 
    local_to_tz_display,
} from 'utils/date';

import { init as setup_modal } from 'ui/modal';
import { MODAL_TEMPLATE, WAITLIST_TEMPLATE } from 'booking-widget/v1/common/templates';
import { show_loading, hide_loading } from 'ui/visibility';
import { form_to_object } from 'ui/data';

export const init = (options) => {
    if (!options) {
        options = {};
    }

    let opts = $.extend({
        modal_id: 'bw-waitlist-modal',
        on_shown: function() {},
        utc_offset: -10,
        trips: function() {}
    }, options);

    if ($('#' + opts.modal_id).length > 0) {
        return;
    }
    let is_submitting = false;
    let capacity = 49;
    // booking_settings should already be cached
    let age_ranges = get_cache('booking_settings-age_ranges');

    setup_modal({
        html: MODAL_TEMPLATE.replace(/\[modal_id\]/g, opts.modal_id),
        on_shown: function(e, params) {
            let modal_el = $('#' + opts.modal_id);
            let tour_id = params.opener_el.attr('data-tour-id');
            $('.bw-waitlist', modal_el).removeClass('success');
            $('input[name="tour_id"]', modal_el).val(tour_id);
            capacity = params.opener_el.attr('data-capacity');

            // trips should be cached already
            let trips = opts.trips();
            if (trips && trips.data && trips.data.length > 0) {
                // get exclusions

                for (let i = 0; i < trips.data.length; i++) {
                    let tv = trips.data[i];
                    let v = tv.vessel[0];
                    if (tv.tour_id != tour_id) {
                        continue;
                    }

                    let str = exclusion_string(v.toddlers_allowed, v.pregnant_allowed);
                    $('.exclusions', modal_el).html(str);
                    if (v.toddlers_allowed != 1) {
                        $('.bw-waitlist__counts', modal_el).addClass('no-toddlers');
                        $('.toddlers-line', modal_el).hide();
                    }
                    else {
                        $('.bw-waitlist__counts', modal_el).removeClass('no-toddlers');
                        $('.toddlers-line', modal_el).show();
                    }
                    break;
                }

            }
            
            opts.on_shown(modal_el);
        }
    });

    let adult_ages = (age_ranges.adult.start || 13) + ' &amp; up';
    let child_ages = (age_ranges.child.start || 6) + '-' + (age_ranges.child.end || 12);
    let toddler_ages = (age_ranges.toddler.start || 3) + '-' + (age_ranges.toddler.end || 5);

    let el = $('.bw-modal__content', '#' + opts.modal_id);
    el.append(WAITLIST_TEMPLATE
                .replace(/\[adult_ages\]/g, esc_html(adult_ages))
                .replace(/\[child_ages\]/g, esc_html(child_ages))
                .replace(/\[toddler_ages\]/g, esc_html(toddler_ages))
    );

    get_settings({
        on_done: function(json) {
            if (json.success && json.data && json.data.waitlist_success) {
                $('.success--waitlist', el).text(json.data.waitlist_success);
            }
        }
    });

    let start_date_el = $('input[name="start_date"]', el);
    let end_date_el = $('input[name="end_date"]', el);
    let date_error_el = $('.date-error', el);
    let daterangepicker_el = $('.bw-waitlist__datepicker', el);

    init_daterangepicker();
    $(document).on('bw-daterangepicker-loaded', function() {
        init_daterangepicker();
    });

    // bc the number input is ugly
    $('.input--number', el).on('blur', function() {
        this.value = parseInt(this.value) || '';
        this.value = Math.max(Math.min(this.value, capacity), 0);
        if (this.name == 'adult') {
            if (this.value == '' || this.value == 0) {
                this.setCustomValidity('At least one adult is required');
            }
            else {
                this.setCustomValidity('');
            }
        }
    });

    $('.bw__icomoon--ca_up, .bw__icomoon--ca_down', el).on('click', function() {
        let input_el = $('input.input--number', $(this).closest('.bw-waitlist__count'));
        let val = parseInt(input_el.val()) || 0;
        if ($(this).hasClass('bw__icomoon--ca_up')) {
            val += 1;
        }
        else {
            val -= 1;
        }

        input_el.val(Math.max(Math.min(val, capacity), 0));
    });

    $('form', el).on('submit', function(e) {
        e.preventDefault();
        if (is_submitting) {
            return;
        }
        
        $('.waitlist-error', el).hide();
        date_error_el.hide();

        is_submitting = true;

        let start_date = tz_display_to_local(daterangepicker_el.data('daterangepicker').startDate._d, opts.utc_offset);
        let end_date = tz_display_to_local(daterangepicker_el.data('daterangepicker').endDate._d, opts.utc_offset);
        show_loading(el);
        _get_trips({
            fields: 'id',
            start_timestamp_between: [start_date.getTime(), end_date.getTime()],
            tour_id: $('input[name="tour_id"]', el).val(),
            order: 'start_time,vessel.booking_priority',
            limit: 1,
            on_done: function(json) {
                if (json.success && json.data && json.data.length > 0) {
                    // add to waitlist
                    let form_data = form_to_object($('form', el));
                    form_data.tour_vessel_id = json.data[0].id;

                    // validate
                    form_data.adult = parseInt(form_data.adult) || 0;
                    form_data.child = parseInt(form_data.child) || 0;
                    form_data.toddler = parseInt(form_data.toddler) || 0;

                    if (form_data.adult == 0) {
                        is_submitting = false;
                        hide_loading(el);
                        return;
                    }

                    if (form_data.adult + form_data.child + form_data.toddler > capacity) {
                        $('.waitlist-error', el).text('The number of passengers exceeds the vessel\'s capacity.').show();
                        hide_loading(el);
                        return;
                    }

                    form_data.contact_id = [];
                    form_data.is_child = [];
                    for (let i = 0; i < form_data.adult; i++ ) {
                        form_data.contact_id.push('');
                        form_data.is_child.push('off');
                    }
                    for (let i = 0; i < (form_data.child + form_data.toddler); i++ ) {
                        form_data.contact_id.push('');
                        form_data.is_child.push('on');
                    }
                    form_data.status = 'Waitlist';
                    form_data.is_waitlisted = 'on';
                    form_data.waitlist_end_dtm = to_system_date(end_date);

                    post_res({
                        data: form_data,
                        on_done: function(json) {
                            is_submitting = false;
                            hide_loading(el);
                            if (json.errors && json.errors.length > 0) {
                                $('.waitlist-error', el).text(json.errors.join('<br />')).show();
                            }
                            else if (json.success == false) {
                                $('.waitlist-error', el).text(json.errors.join('Your request could not be processed at this time.  Please try again.')).show();
                            }
                            else {
                                $('.bw-waitlist', el).addClass('success');
                            }
                        }
                    });
                }
                else {
                    date_error_el.text('No tours available during this time.').show();
                    is_submitting = false;
                    hide_loading(el);
                }
            }
        });
    });


    function init_daterangepicker() {
        if (!$.fn.daterangepicker) {
            return;
        }
        if (daterangepicker_el.hasClass('drp-initialized')) {
            return;
        }
        daterangepicker_el.daterangepicker({
            minDate: local_to_tz_display(new Date(), opts.utc_offset),
            maxSpan: { weeks: 6 },
            autoApply: true
        })
        .on('apply.daterangepicker', function(ev, picker) {
            let start_date = picker.startDate.toDate();
            let end_date = picker.endDate.toDate();
            start_date_el.val(start_date);
            end_date_el.val(end_date);
        })
        .addClass('drp-initialized')
    ;
    }

}